import React, { useState } from "react"; // ← esta linha é essencial
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";              // 🟢 NOVO
import Button from "@mui/material/Button";            // 🟢 NOVO
import Fade from "@mui/material/Fade";           // ← IMPORT NECESSÁRIO
import IconButton from "@mui/material/IconButton"; // ← IMPORT NECESSÁRIO
import CloseIcon from "@mui/icons-material/Close"; // ← IMPORT NECESSÁRIO

// Vision UI components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar"; // ORIGINAL do sistema
import DefaultNavbar from "examples/Navbars/DefaultNavbar"; // ← novo import ALTERADO HOJE 30/04
import Footer from "examples/Footer";
import { Opacity } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import { Link, useHistory } from "react-router-dom"; // 🟢 MODIFICADO: adiciona useNavigate

function Dashboard() {
  const isChrome =
    typeof window !== "undefined" &&
    /Chrome/.test(navigator.userAgent) &&
    /Google Inc/.test(navigator.vendor);
  const isSmallScreen = useMediaQuery("(max-width:389px)");
  const isExtraSmallScreen = useMediaQuery("(max-width:374px)");
  const [selectedService, setSelectedService] = useState(null); // ← guarda o card selecionado
  const history = useHistory(); // ← permite redirecionamento com filtro na URL

  const handleOpen = (service) => setSelectedService(service); // ← abre o modal
  const handleClose = () => setSelectedService(null);          // ← fecha o modal

  const handleNavigate = (category) => {
    history.push(`/portfolio?filter=${encodeURIComponent(category)}`);
    handleClose();
  }; // ← FECHAMENTO ESSENCIAL  

  const mainServices = [
    {
      icon: "🖌️",
      title: "UX/UI Design",
      description: "Criação de interfaces intuitivas, responsivas e com foco em usabilidade.",
      descriptionLong: "Projetos de UI/UX para web, landing pages e campanhas de marketing digital. Design centrado no usuário, com foco em performance e identidade visual.",
      categories: ["Web / UI", "Landing Pages", "Marketing Digital"],
    },
    {
      icon: "📦",
      title: "TI e Automações",
      description: "Desenvolvimento de sistemas inteligentes e integração com IA.",
      descriptionLong: "Criação de micro SaaS, automações com inteligência artificial, APIs personalizadas e soluções para otimizar processos técnicos e administrativos.",
      categories: ["IA e Automações", "Micro SaaS"],
    },
    {
      icon: "🏷️",
      title: "Design Gráfico",
      description: "Identidade visual, branding e materiais editoriais ou publicitários.",
      descriptionLong: "Criação de logomarcas, revistas, catálogos, folders e campanhas publicitárias para impressão ou mídias digitais, com acabamento profissional e foco estratégico.",
      categories: ["Design Gráfico"],
    },
  ];  

  return (
    <DashboardLayout>
      <DefaultNavbar />
      <VuiBox py={3}>
        <Card>
          <CardContent>
            {/* Bloco superior com imagem e texto lado a lado */}
            <Grid container spacing={4} alignItems="center">
              {/* Coluna do Texto UX/UI - aparece primeiro em telas pequenas */}
              <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
                <VuiBox textAlign="left" px={2}>
                  <VuiTypography variant="button" color="success" fontWeight="bold" mb={1}>
                    Olá, eu sou Alexandre
                  </VuiTypography>

                  <VuiTypography variant="h2" color="white" fontWeight="bold" mb={2}>
                    UX/UI/TI Designer
                  </VuiTypography>

                  <VuiTypography variant="body2" color="text" maxWidth="500px" mb={3}>
                    Profissional com visão integrada e sensível às transformações do nosso tempo. Acredito que estamos vivendo uma verdadeira revolução nos processos criativos, onde a tecnologia, a inteligência artificial e a automação caminham lado a lado com o conhecimento humano, o design e a empatia.  
                    Mais do que entregar projetos, ajudo empresas e profissionais a encontrarem soluções inteligentes, éticas e conectadas com seus desafios reais. 
                  </VuiTypography>

                  <VuiBox>
                  <Link to="/sobre" style={{ textDecoration: "none" }}>
                    <button
                      style={{
                        background: "#A3E635",
                        border: "none",
                        padding: "10px 24px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        color: "#141727",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow = "0px 4px 16px rgba(163, 230, 53, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      SOBRE MIM
                    </button>
                  </Link>
                </VuiBox>

                </VuiBox>
              </Grid>

              {/* Coluna da Imagem - aparece depois em telas pequenas */}
              <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
              <VuiBox
                position="relative"
                width="100%"
                height="auto"
                display="flex"
                alignItems="center"
                justifyContent="center"
                px={2} // padding horizontal para prevenir estouro
              >
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}/assets/img/perfil/modelo1.webp`}
                  alt="UX Designer"
                  sx={{
                    width: "100%",
                    maxWidth: {
                      xs: "100%",  // usa o máximo da coluna (com padding interno)
                      sm: "90%",
                      md: "85%",
                      lg: "75%",
                      xl: "65%",
                    },
                    height: "auto",
                    objectFit: "contain",
                    marginBottom: {
                      xs: "-40px",
                      sm: "-50px",
                      md: "-60px",
                    },
                    position: "relative",
                    zIndex: 1,
                  }}
                />
                                        
                {/* Luz verde difusa atrás da imagem */}
                <VuiBox
                  sx={{
                    position: "absolute",
                    bottom: "0",
                    left: "50%",
                    top:"20px",
                    transform: "translateX(-50%)",
                    width: "500px",
                    height: "500px",
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(165, 228, 69, 0.3) 0%, rgba(165, 228, 69, 0) 80%)",
                    filter: "blur(40px)",
                    zIndex: 0,
                    pointerEvents: "none",
                  }}
                  />
                </VuiBox>
              </Grid>
            </Grid>

            {/* Estatísticas abaixo das colunas */}
            <VuiBox
                mt={0}
                py={4}
                px={3}
                sx={{
                paddingTop: {
                  xs: "35px", // mais espaço para telas pequenas
                  md: "35px",  // padrão para desktop
                },
                background: isExtraSmallScreen
                ? "rgba(255, 255, 255, 0.05)" // mais contraste só para telas < 375px
                : {
                    xs: isChrome
                      ? "radial-gradient(ellipse 60% 50% at top, rgb(66, 85, 33) 0%, rgb(21, 26, 52) 80%)"
                      : "linear-gradient(to bottom, rgba(255,255,255,0.03), rgba(163,230,53,0.05))",
                    md: isChrome
                      ? "radial-gradient(ellipse 20% 90% at 25% 0%, rgb(66, 85, 33) 0%, rgb(21, 26, 52) 80%)"
                      : "linear-gradient(to bottom, rgba(255,255,255,0.03), rgba(163,230,53,0.05))",
                  },

                backdropFilter: isChrome ? "none" : "blur(50px)",
                WebkitBackdropFilter: isChrome ? "none" : "blur(50px)",
                borderRadius: "20px",
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
                zIndex: 2,
                position: "relative",
                willChange: "backdrop-filter",
                transition: "background 0.3s ease",
              }}
            >

              {[
                { label: "Years experience", value: "30+" },
                { label: "Clients", value: "120+" },
                { label: "Completed projects", value: "500+" },
                { label: "Achievements", value: "19+" },
              ].map((item, index) => (
                <VuiBox key={index} textAlign="center" m={2} minWidth="120px">
                  <VuiTypography color="white" variant="h4" fontWeight="bold">
                    {item.value}
                  </VuiTypography>
                  <VuiTypography color="text" variant="caption">
                    {item.label}
                  </VuiTypography>
                </VuiBox>
              ))}
            </VuiBox>

            {/* Serviços (mantidos como estavam) */}
            <VuiBox mt={6}>
              <VuiTypography variant="h4" color="white" fontWeight="bold" mb={4} textAlign="center">
                Serviços e Soluções
              </VuiTypography>

              <Grid container spacing={3}>
                {mainServices.map((service, idx) => (
                  <Grid item xs={12} md={4} key={idx}>
                    <Card
                      onClick={() => handleOpen(service)}
                      sx={{
                        backgroundColor: idx === 1 ? "#2A2B3D" : "#1E1F2F",
                        p: 3,
                        borderRadius: "16px",
                        height: "100%",
                        boxShadow: idx === 1 ? "0 0 0 2px #A3E635" : undefined,
                        cursor: "pointer",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 4px 20px rgba(163, 230, 53, 0.2)",
                        },
                      }}
                    >
                      <VuiTypography variant="h5" color="white" fontWeight="bold" mb={2}>
                        {service.icon} {service.title}
                      </VuiTypography>
                      <VuiTypography variant="body2" color="text">
                        {service.description}
                      </VuiTypography>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              <Modal open={!!selectedService} onClose={handleClose} closeAfterTransition>
                <Fade in={!!selectedService}>
                  <Card
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "#002b40", // 1E1F2F
                      p: 4,
                      width: "90%",
                      maxWidth: 600,
                      borderRadius: "16px",
                      boxShadow: 24,
                    }}
                  >
                    {selectedService && (
                      <>
                        {/* ❌ Botão de fechar */}
                        <IconButton
                          onClick={handleClose}
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "#fff",
                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                            "&:hover": {
                              backgroundColor: "rgba(255, 255, 255, 0.15)",
                            },
                          }}
                        >
                          <CloseIcon />
                        </IconButton>

                        {/* Conteúdo do modal */}
                        <VuiTypography variant="h5" color="white" fontWeight="bold" mb={2}>
                          {selectedService.title}
                        </VuiTypography>
                        <VuiTypography variant="body2" color="text" mb={4}>
                          {selectedService.descriptionLong}
                        </VuiTypography>

                        {selectedService.categories.map((cat, i) => (
                          <Button
                            key={i}
                            variant="contained"
                            onClick={() => handleNavigate(cat)}
                            sx={{
                              backgroundColor: "#A3E635",
                              color: "#141727",
                              fontWeight: "bold",
                              textTransform: "none",
                              m: 0.5,
                              borderRadius: "8px",
                              "&:hover": {
                                backgroundColor: "#B7F961",
                              },
                            }}
                          >
                            Ver projetos relacionados: {cat}
                          </Button>
                        ))}
                      </>
                    )}
                  </Card>
                </Fade>
              </Modal>

            </VuiBox>

          </CardContent>
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;